import styled from 'styled-components';
import {
  Input,
  Checkbox,
  Icon,
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background-color: #fff;
`;

export const BoxSelect = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
`;

export const ItensList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: scroll;
  border-radius: 3px;
  padding: 0 10px 10px 10px;
  height: 220px;
  max-height: 220px;
`;

export const MoreCountriesDiv = styled.div`
  display: flex;
  gap: 5px;
  margin: 10px;
  margin-left: 0px;
  margin-bottom: 0px;
`;

export const OtherCountriesDiv = styled.div`
  display: flex;
  gap: 3px;
`;

export const MoreCountriesBold = styled.p`
  font-weight: 500;
`;

export const QuestionMarkIcon = styled(Icon)`
  && {
    font-size: 0.6em;
    margin: 0;
    height: unset;
  }
`;

export const ContainerIcon = styled.div`
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e3eefc;
  width: 15px;
  height: 15px;
`;

export const BoxItens = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding:  0 10px 10px 10px;
`;

export const BoxSearch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  span {
    margin-left: 20px;
    cursor: pointer;
  }
`;

export const InputFind = styled(Input)`
  width: 80%;
  height: 35px;
  padding: 10px;
  background-color: ${(props) => props.theme.color.categorizingBackground};
  border-radius: 30px;
  border: none;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
  word-wrap: break-word;
  outline: none;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    background: transparent !important;
    border: 0 !important;
  }
`;

export const ErrorMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  span {
    color: red;
    font-weight: 500;
    font-size: 0.75rem;
  }
`;

export const Itens = styled.div`
  color: ${(props) => props.theme.color.categorizingColor};
  font-size: 16px;
  font-weight: 500;
`;

export const SubItens = styled.div``;

export const Radio = styled(SemanticRadio)`
  margin-right: 5px;
  padding: 4px 0;`;

export const CheckboxInput = styled(Checkbox)`
  margin-right: 5px;
  padding: 4px 0;
`;

export const Message = styled(TextLayoutComponent)`
  margin-bottom: 10px;
`;
